
// src/services/alphaVantage/client.ts
import axios from 'axios';
import { apiKeyManager } from './keyManager';
import { rateLimiter } from './rateLimiter';

const BASE_URL = 'https://www.alphavantage.co/query';

export const alphaVantageClient = {
  fetchTimeSeriesDaily: async (symbol: string) => {
    await rateLimiter.acquireToken();
    
    const apiKey = apiKeyManager.getNextKey();
    rateLimiter.setTier(apiKeyManager.getTierForKey(apiKey));
    
    try {
      const response = await axios.get(BASE_URL, {
        params: {
          function: 'TIME_SERIES_DAILY',
          symbol,
          outputsize: 'compact',
          apikey: apiKey
        }
      });
      
      // Check if the response indicates an API limit reached
      if (response.data && typeof response.data === 'object' && 
          'Note' in response.data && 
          typeof response.data.Note === 'string' &&
          response.data.Note.includes('call frequency')) {
        apiKeyManager.disableKey(apiKey);
        // Retry with a different key
        return alphaVantageClient.fetchTimeSeriesDaily(symbol);
      }
      
      return response.data;
    } catch (error) {
      console.error(`Error fetching data for ${symbol}:`, error);
      throw error;
    }
  },
  
  fetchIntraday: async (symbol: string, interval: string) => {
    await rateLimiter.acquireToken();
    
    const apiKey = apiKeyManager.getNextKey();
    rateLimiter.setTier(apiKeyManager.getTierForKey(apiKey));
    
    try {
      const response = await axios.get(BASE_URL, {
        params: {
          function: 'TIME_SERIES_INTRADAY',
          symbol,
          interval,
          outputsize: 'compact',
          apikey: apiKey
        }
      });
      
      // Check if the response indicates an API limit reached
      if (response.data && typeof response.data === 'object' && 
          'Note' in response.data && 
          typeof response.data.Note === 'string' &&
          response.data.Note.includes('call frequency')) {
        apiKeyManager.disableKey(apiKey);
        // Retry with a different key
        return alphaVantageClient.fetchIntraday(symbol, interval);
      }
      
      return response.data;
    } catch (error) {
      console.error(`Error fetching intraday data for ${symbol}:`, error);
      throw error;
    }
  }
};
